export function GetObjectRecordID(dataObject) {
  if (dataObject == null) return null;

  return dataObject.GetObjectRecordID();
}
